import React from 'react'
import {TimelineMax,Power2} from 'gsap'
import DrawSVG from "gsap/DrawSVGPlugin";
import SVG from 'react-inlinesvg';

class MenuBurger extends React.Component {


  constructor(props){
    super();
    this.state ={
        burger_tl: null,
        intro_tl:null,
        mouseOver_tl:null,

    }

    this.onMouseOut = this.onMouseOut.bind(this)
    this.onMouseOver = this.onMouseOver.bind(this)
    this.onClick = this.onClick.bind(this)
  }

  componentDidMount(){
    this.animateIn();
  }

  componentWillUpdate(newProps,newState){
    //  console.log("MenuBurger",newProps,newState);
  }



  animateIn(){

    let intro_tl = new TimelineMax({repeat:0})
    intro_tl.from(this.refs.line1,.2,{left:'30%',width:'0%'},'-=.2')
    intro_tl.from(this.refs.line2,.2,{left:'30%',width:'0%'},'-=.2')
    intro_tl.from(this.refs.line3,.2,{left:'30%',width:'0%'},'-=.2')





  }

  setupAnimation(){


    //mouseOver_tl

    let mouseOver_tl = new TimelineMax({repeat:0})
    mouseOver_tl.to(this.refs.line1,.1,{top:7},'-=0')
    mouseOver_tl.to(this.refs.line2,.1,{top:7},'-=.1')
    mouseOver_tl.to(this.refs.line3,.1,{top:7},'-=.1')

    mouseOver_tl.set(this.refs.line1,{width:'55%'})
    mouseOver_tl.set(this.refs.line2,{width:'55%'})
    mouseOver_tl.set(this.refs.line3,{autoAlpha:0})

    mouseOver_tl.to(this.refs.line1,.1,{rotation:55, top:11, left:-3 },'-=0')
    mouseOver_tl.to(this.refs.line2,.1,{rotation:-55, top:12, left:13},'-=.1')
    mouseOver_tl.set(this.refs.line1,{autoAlpha:0})
    mouseOver_tl.set(this.refs.line2,{autoAlpha:0})
    mouseOver_tl.set(this.refs.arrow,{autoAlpha:1})

    mouseOver_tl.pause();

    //mouseOver_tl.progress(0)
    this.setState({mouseOver_tl})
  }

  onMouseOver(){
    if(!this.props.open){
      this.state.mouseOver_tl.pause()
      this.state.mouseOver_tl.play()
    }
  }
  onMouseOut(){
    if(!this.props.open){
      this.state.mouseOver_tl.pause()
      this.state.mouseOver_tl.reverse()
    }
  }

  onClick(){
    if(this.state.mouseOver_tl.duration()!==this.state.mouseOver_tl.time()){
      this.state.mouseOver_tl.pause()
      this.state.mouseOver_tl.play()
    }
    this.props.onClick();
  }

  componentDidMount(){
    this.setupAnimation();
  }

  componentWillUpdate(newProps,newState){

      //console.log(newProps);
      if(newProps.open===false && this.state.mouseOver_tl){
        //setTimeout(()=>{
          this.state.mouseOver_tl.pause()
          this.state.mouseOver_tl.reverse()
        //},500)
      }
  }

  render () {

      let openClass = (this.props.open)? 'open' : 'closed';

      return (
          <div className="menu-burger-holder" onClick={this.onClick} onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}>
          <div className={"menu-burger "+(openClass)}  >
              <div className="arrow" ref="arrow">
              <img src="/assets/global/scroll_arrow_blue.svg" />
              </div>
              <div className="line1" ref="line1" />
              <div className="line2" ref="line2" />
              <div className="line3" ref="line3" />
           </div>
           </div>
      )
  }
}

export default MenuBurger;



// WEBPACK FOOTER //
// ./src/modules/menu/MenuBurger.js